import { useState } from 'react';
import Graphic from './Graphic';
import Core from '../../Core';
import Upload from './Upload';
import Execution from './Execution';
import SearchEnginesRegister from '../Register';
import Managing from './Managing';
import CurveLeveling from './CurveLeveling';

export default function CurveLevelingGraphic() {
  const [navOption, setNavOption] = useState<string>('execution');

  return (
    <Core withBlueBar withNavbar path="" label="">
      <div className="flex align-middle justify-center">
        <div>
          <header className="w-[92vw]">
            <nav>
              <ul className="flex flex-col md:flex-row flex-wrap gap-[.1rem] text-center">
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem]  ${navOption === 'execution' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}  rounded-tl-xl rounded-tr-xl md:rounded-tr-none flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('execution')}
                >
                  EXECUÇÃO
                </li>
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem] ${navOption === 'up' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}   flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('up')}
                >
                  UPLOAD
                </li>
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem] ${navOption === 'fa_fn' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}  flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('fa_fn')}
                >
                  FATOR DE CURVA E NIVELAÇÃO
                </li>
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem] ${navOption === 'graphic' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}  flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('graphic')}
                >
                  GRÁFICO DE COMPARAÇÃO
                </li>
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem] ${navOption === 'register' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}  flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('register')}
                >
                  CADASTRO DE MODELO
                </li>
                <li
                  className={`flex justify-center  items-center text-[12px] py-[.7rem] md:py-[.5rem] md:whitespace-nowrap	 px-[.1rem] lg:text-[16px] sm:px-[1.3rem] ${navOption === 'managing' ? 'bg-[#00aeef]' : 'bg-[#00000033]'}  md:rounded-tr-xl flex text-white text-base flex-wrap hover:cursor-pointer`}
                  onClick={() => setNavOption('managing')}
                >
                  GERENCIAMENTO
                </li>
              </ul>
            </nav>
          </header>
          <section className="bg-[#f2f2f2] border-[1px] border-[#b9b9b9]  h-max rounded-b-xl w-[92vw]">
            {navOption === 'execution' ? (
              <Execution />
            ) : navOption === 'up' ? (
              <Upload />
            ) : navOption === 'register' ? (
              <SearchEnginesRegister />
            ) : navOption === 'fa_fn' ? (
              <CurveLeveling />
            ) : navOption === 'graphic' ? (
              <Graphic />
            ) : (
              <Managing />
            )}
          </section>
        </div>
      </div>
    </Core>
  );
}
